const runtimeConfig = typeof window !== "undefined" && window.__APP_CONFIG__ ? window.__APP_CONFIG__ : {};

const isLocalEnvironment = () => {
  if (typeof window === "undefined") {
    return process.env.NODE_ENV !== "production";
  }
  return /^(localhost|127\.0\.0\.1|\[::1\])$/i.test(window.location.hostname);
};

const buildLocalUrl = (port, path = "") => {
  const protocol = typeof window !== "undefined" && window.location.protocol ? window.location.protocol : "http:";
  const base = `${protocol}//localhost:${port}`;
  return path ? `${base}${path.startsWith("/") ? path : `/${path}`}` : base;
};

const resolveUrl = (envValue, fallbackPort, path = "") => {
  if (isLocalEnvironment()) {
    return buildLocalUrl(fallbackPort, path);
  }
  return envValue || (typeof window !== "undefined" ? `${window.location.origin}${path}` : buildLocalUrl(fallbackPort, path));
};

const resolveApiBase = (path = "", fallbackPort = 8080) => {
  if (isLocalEnvironment()) {
    return buildLocalUrl(fallbackPort, path);
  }
  return process.env.REACT_APP_API_BASE || process.env.REACT_APP_API_URL || (typeof window !== "undefined" ? `${window.location.origin}${path}` : buildLocalUrl(fallbackPort, path));
};

const resolvePaymentPortalUrl = () => {
  if (isLocalEnvironment()) {
    return buildLocalUrl(3002);
  }
  return process.env.REACT_APP_PAYMENT_PORTAL_URL || "https://pay.cliniqueue.in";
};

const defaultConfig = {
  port: Number(process.env.REACT_APP_PORT || 3002),
  authAppUrl: resolveUrl(process.env.REACT_APP_LOGIN_URL || process.env.REACT_APP_AUTH_APP_URL, 3001),
  dashboardUrl: resolveUrl(process.env.REACT_APP_APP_URL || process.env.REACT_APP_DASHBOARD_URL, 3002),
  paymentPortalUrl: resolvePaymentPortalUrl(),
  apiBase: resolveApiBase("/api", 8080),
};

export const appConfig = {
  port: runtimeConfig.port || process.env.REACT_APP_PORT || defaultConfig.port,
  authAppUrl: runtimeConfig.authAppUrl || process.env.REACT_APP_LOGIN_URL || process.env.REACT_APP_AUTH_APP_URL || defaultConfig.authAppUrl,
  dashboardUrl: runtimeConfig.dashboardUrl || process.env.REACT_APP_APP_URL || process.env.REACT_APP_DASHBOARD_URL || defaultConfig.dashboardUrl,
  paymentPortalUrl: runtimeConfig.paymentPortalUrl || process.env.REACT_APP_PAYMENT_PORTAL_URL || defaultConfig.paymentPortalUrl,
  apiBase: runtimeConfig.apiBase || process.env.REACT_APP_API_BASE || defaultConfig.apiBase,
};

export default appConfig;
